import { INavigation } from '../types';

export const TITLE: string = 'title';
export const PATH: string = 'path';

export const MAIN: string = 'main';
export const AUTHORIZATION: string = 'authorization';
export const EMAILS: string = 'emails';
export const VOLUNTEERS: string = 'volunteers';

export const NAVIGATION: Array<INavigation> = [
  {
    id: MAIN,
    title: 'Главная',
    path: '/',
    isSidebarItem: false,
    isDeveloping: false,
  },
  {
    id: AUTHORIZATION,
    title: 'Вход в систему',
    path: '/authorization',
    isSidebarItem: false,
    isDeveloping: false,
  },
  {
    id: VOLUNTEERS,
    title: 'Анкеты волонтёров',
    path: '/' + VOLUNTEERS,
    isSidebarItem: true,
    isDeveloping: true,
  },
];
